import {
  GET_PRINT_TEMPLATE,
  GET_PRINT_TEMPLATE_SUCCESS,
  GET_PRINT_TEMPLATE_FAIL,
  DELETE_PRINT_TEMPLATE,
  DELETE_PRINT_TEMPLATE_SUCCESS,
  DELETE_PRINT_TEMPLATE_FAIL,
  UPDATE_PRINT_TEMPLATE,
  UPDATE_PRINT_TEMPLATE_SUCCESS,
  UPDATE_PRINT_TEMPLATE_FAIL,
  ADD_NEW_PRINT_TEMPLATE,
  ADD_PRINT_TEMPLATE_SUCCESS,
  ADD_PRINT_TEMPLATE_FAIL,
  PRINT_TEMPLATE_LOADING,
  PRINT_TEMPLATE_RESET,
} from "./actionType";

export const resetPrintTemplateState = (actionType) => ({
  type: PRINT_TEMPLATE_RESET,
  payload: { actionType },
});

export const getPrintTemplateSuccess = (actionType, data) => ({
  type: GET_PRINT_TEMPLATE_SUCCESS,
  payload: { actionType, data },
});

export const getPrintTemplateFail = (actionType, error) => ({
  type: GET_PRINT_TEMPLATE_FAIL,
  payload: { actionType, error },
});

export const getPrintTemplate = data => ({
  type: GET_PRINT_TEMPLATE,
  payload: data,
});

export const getPrintTemplateLoading = () => ({
  type: PRINT_TEMPLATE_LOADING
});

export const deletePrintTemplate = data => ({
  type: DELETE_PRINT_TEMPLATE,
  payload: data,
});

export const deletePrintTemplateSuccess = data => ({
  type: DELETE_PRINT_TEMPLATE_SUCCESS,
  payload: data,
});

export const deletePrintTemplateFail = error => ({
  type: DELETE_PRINT_TEMPLATE_FAIL,
  payload: error,
});

export const updatePrintTemplate = data => ({
  type: UPDATE_PRINT_TEMPLATE,
  payload: data,
});

export const updatePrintTemplateFail = error => ({
  type: UPDATE_PRINT_TEMPLATE_FAIL,
  payload: error,
});

export const updatePrintTemplateSuccess = data => ({
  type: UPDATE_PRINT_TEMPLATE_SUCCESS,
  payload: data,
});

export const addNewPrintTemplate = data => ({
  type: ADD_NEW_PRINT_TEMPLATE,
  payload: data,
});

export const addPrintTemplateSuccess = data => ({
  type: ADD_PRINT_TEMPLATE_SUCCESS,
  payload: data,
});

export const addPrintTemplateFail = error => ({
  type: ADD_PRINT_TEMPLATE_FAIL,
  payload: error,
});